import { firebaseAction } from 'vuexfire'
import { db } from '@/db'

const categories = db.collection('categories')

const state = {
  categories: null
}

const actions = {
  getCategories: firebaseAction(({ bindFirebaseRef }, course) => {
    bindFirebaseRef('categories',
      categories
        .where('courseId', '==', course.id)
        .orderBy('title')
    )
  })
}

const getters = {
  currentCategories: (state) => {
    return state.categories
  }
}

const namespaced = true

export default {
  namespaced,
  state,
  actions,
  getters
}
